import { IconButton, List, ListItemText, ListItem } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import ContentLoader from '@components/ContentLoader';
import Icon from '@components/Icon/Icon';

import type { DiagnosticReportRecord } from '@models/diagnostic-report';

import { useDeletePacsStudies } from 'generated/diagnostic-report.generated';

const messages = defineMessages({
  deleteConfirm: {
    id: 'dicomImageList.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this DICOM Imaging Study?',
  },
  deleteConfirmation: {
    id: 'GLOBAL.deleteConfirmation',
    defaultMessage: 'To confirm deletion, type {phrase} in the field.',
  },
  deletePhrase: {
    id: 'confirmation.deletePhrase',
    defaultMessage: 'DELETE',
  },
});

interface ImagingStudyListProps {
  diagnosticReport?: DiagnosticReportRecord | null;
}

const ImagingStudyList: React.FC<ImagingStudyListProps> = ({
  diagnosticReport,
}) => {
  const { formatMessage } = useIntl();
  const [deleteStudies, { loading }] = useDeletePacsStudies();
  const studies = diagnosticReport?.imagingStudies ?? [];

  const handleDelete = async (study_id?: string | null) => {
    if (!study_id || !diagnosticReport?.id) {
      return;
    }
    await deleteStudies({
      variables: {
        input: {
          diagnostic_report_id: diagnosticReport.id,
          pacs_study_ids: [study_id],
        },
      },
    });
  };

  return (
    <List>
      <ContentLoader loading={loading}>
        {studies.map((study) => {
          return (
            <ListItem
              key={study.id}
              secondaryAction={
                <ConfirmationDialog
                  challenge={{
                    description: formatMessage(messages.deleteConfirmation, {
                      phrase: formatMessage(messages.deletePhrase),
                    }),
                    phrase: formatMessage(messages.deletePhrase),
                  }}
                  onConfirm={async () => handleDelete(study.orthancStudyId)}
                  title={formatMessage(messages.deleteConfirm)}
                >
                  {({ handleOpen }) => (
                    <IconButton aria-label="delete" edge="end">
                      <Icon name="trash" onClick={handleOpen} />
                    </IconButton>
                  )}
                </ConfirmationDialog>
              }
            >
              <ListItemText primary={study.studyName} />
            </ListItem>
          );
        })}
      </ContentLoader>
    </List>
  );
};

export default ImagingStudyList;
